import '../assets/css/secondMobPage.css'
import { useEffect, useRef, useState } from 'react'
import logoBabitaWShdw from '../assets/imgs/Initial/logoBabitaBShdw.png'
import { useNavigate } from 'react-router-dom'




export default function SecondMobPage(props){



     const navigate = useNavigate()
    useEffect(()=>{
        document.getElementsByTagName('body')[0].className = "secondMobPageBdy";
    },[])

  
    
    return <>
        <div className="containerPrincipal secondMobPage" >

            <div className="containerLogoBabita">
                <img src={logoBabitaWShdw} alt="Logo Babita" className="logoBabita" />
            </div>

            <div className="titleQuest">Bem vinda, Como deseja continuar?</div>


            <div className="enterOptions">
<div className="option" onClick={() => window.location.href = 'https://wa.me/5531986524600/?text=Ola!%20vim%20pelo%20Site%20da%20Babita%20e%20gostaria%20de%20revender'/*'5531998210779'*/}>Quero revender</div>
                <div className="option" onClick={() => navigate('/HomePage')}>Conhecer Babita</div>
                <div className="option" onClick={() => navigate('/HomePage')}>Já faço parte do #TIMEBABITA</div>
            </div>


        </div>
    </>
}